import Types from "./types";
import AssessmentServiceApi from "../../services/assessment-api";
import { createCookie, readCookie } from "../../utils/helpers";
import FunnelStepTypes from "../funnel-step/types";

const quack = () => ({
  type: Types.QUACK,
});

const loginUserAsAdminAndAuthenticate = (data) => {
  return function (dispatch) {
    return AssessmentServiceApi.loginAsAdmin(data)
      .then((authResponse) => {
        const { jwtToken, refreshToken, expiresAt } =
          authResponse?.insightfulUserToken;
        localStorage.setItem("jwtToken", jwtToken);
        localStorage.setItem("refreshToken", refreshToken);
        localStorage.setItem("expiresAt", expiresAt);
        createCookie("jwtToken", jwtToken, 1);
        createCookie("refreshToken", refreshToken, 1);
        createCookie("expiresAt", expiresAt, 1);
        return AssessmentServiceApi.loginUser(data?.userEmail)
          .then((response) => {
            if (response) {
              createCookie("userguid", response?.userGuid, 1);
              createCookie(
                "uname",
                response?.firstName + " " + response?.lastName,
                1
              );
              createCookie("accnum", response?.accountNumber, 1);

              dispatch(
                PushUserInformationToFunnelStep({
                  email: data.userEmail,
                  userGUID: response.userGuid,
                  gender: response.gender,
                })
              );

              return response;
            } else {
              return response;
            }
          })
          .catch((error) => console.log("Error", error));
      })
      .catch((error) => console.log("Error", error));
  };
};

const PushUserInformationToFunnelStep = (userInformation) => ({
  type: FunnelStepTypes.SET_USERINFO,
  payload: userInformation,
});

export { quack, loginUserAsAdminAndAuthenticate };
